import { Button, Modal } from 'react-bootstrap';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { Section } from './styled';
import Globals from '../../../../../../Globals.json';
import { useAppSelector } from '../../../../../../redux/store';
import { IoIosAddCircle } from 'react-icons/io';
import { notify, notifyError } from '../../../../../notify/notify-component';
import api from '../../../../../../Services/api';
import { InputDefault } from '../../../../../data/inputDefault';
import tableStyleDefaul from '../../../../../../Services/tableStyleDefault';
import DataTable from 'react-data-table-component';
import { paginationOptions } from '../../../../../data/PagineteInfo';
import CustomLoader from '../../../../../data/customLoader';
import { useProductsCombined } from '../../../../../../apiQuery/useProductsCombined';
import tableStyleDefaultBolder from '../../../../../../Services/tableStyleDefaultBolder';

interface IProps {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  setCategoriesComplement: Dispatch<SetStateAction<any[]>>;
  categoriesList: any;
}

export default function ModalADD({
  show,
  setShow,
  categoriesList,
  setCategoriesComplement,
}: IProps) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [name, setName] = useState<string>();

  const {
    data: productsList,
    isLoading,
    isError,
  } = useProductsCombined({
    name: name,
    storeId: storeMe?.storeActive?.id,
  });

  const columns: any = [
    {
      name: 'Código',
      sortable: true,
      width: '100px',
      center: true,
      selector: (row: any) => row.id_pdv,
    },
    {
      name: 'Produto',
      minWidth: '190px',
      sortable: true,
      selector: (row: any) => row.sale_name?.toLowerCase(),
    },
    {
      name: 'Adicionar',
      cell: (row: any) => (
        <div className="actions">
          <IoIosAddCircle
            size={20}
            data-toggle="tooltip"
            data-placement="top"
            title="Adicionar"
            className="action"
            onClick={() => handleAdd(row)}
            style={{ marginRight: 16 }}
            color="#3C7EDF"
          />
        </div>
      ),
      button: true,
    },
  ];

  const handleClose = () => {
    setShow(false);
    setSelectedRows([]);
  };

  const handleAdd = (complement: any) => {
    const alreadyExists = categoriesList?.find(
      (item: any) => item?.id === complement?.id
    );

    if (alreadyExists) {
      notify('Complemento já adicionado.');
      return;
    }
    setCategoriesComplement((prevent: any = []) => [
      ...(Array.isArray(prevent) ? prevent : []),
      complement,
    ]);
  };

  const handleAddInBulk = () => {
    if (categoriesList?.length > 0) {
      for (let index = 0; index < selectedRows?.length; index++) {
        const alreadyExists = categoriesList?.find(
          (item: any) => item?.id === selectedRows[index]?.id
        );

        if (alreadyExists) {
          return;
        } else {
          setCategoriesComplement((prevent: any) => [
            ...prevent,
            selectedRows[index],
          ]);
          handleClose();
        }
      }
    } else {
      setCategoriesComplement(selectedRows);
      handleClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      style={{ fontSize: '12px' }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>Adicionar observação</h3>
        </Modal.Title>
      </Modal.Header>
      <div>
        <Modal.Body>
          <Section>
            <InputDefault
              label="Produto"
              placeholder="Produto"
              type="text"
              state={name}
              setState={setName}
            />
          </Section>

          <DataTable
            columns={columns}
            data={productsList}
            striped
            pagination
            paginationDefaultPage={1}
            paginationPerPage={10}
            customStyles={tableStyleDefaultBolder}
            paginationComponentOptions={paginationOptions}
            progressComponent={<CustomLoader />}
            progressPending={isLoading}
            noDataComponent="Nenhuma informação foi encontrada."
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
          {selectedRows?.length > 0 && (
            <Button variant="primary" onClick={handleAddInBulk}>
              Salvar
            </Button>
          )}
        </Modal.Footer>
      </div>
    </Modal>
  );
}
